import * as React from 'react';
import { Tag } from 'app/components/tag';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { IntlShape } from 'react-intl';
import { formatDate } from '../utils';
import { CaseDraftsMeatball } from './case-drafts-table-meatball';
import { MyCaseDraftsTranslation } from 'app/area/my-case-drafts/constants';
import { CaseDraftRow } from 'app/area/my-case-drafts/types-store';
import styles from './case-drafts-table.scss';

interface CaseDraftsTableRowsProps {
  rows: CaseDraftRow[];
  onDelete: (draftId: number) => void;
  translation: MyCaseDraftsTranslation;
  intl: IntlShape;
  tableContainerRef: React.RefObject<HTMLDivElement | null>;
  portalTarget?: HTMLElement | null;
}

export const CaseDraftsTableRows = React.memo(({
  rows,
  onDelete,
  translation,
  intl,
  tableContainerRef,
  portalTarget
}: CaseDraftsTableRowsProps) => (
  <div className={styles.caseDraftsTable} ref={tableContainerRef}>
    <table>
      <tbody>
        {rows.map(row => (
          <tr key={row.draftId}>
            <td><Tag className={styles.tag}>{translation.my_case_drafts_tag}</Tag></td>
            <td>
              <Link to={routeConstants.draftViewFor(row.draftId)} className={styles.draftIdLink}>
                {row.draftId}
              </Link>
            </td>
            <td>{row.caseType?.d ?? ''}</td>
            <td>{formatDate(row.modifiedDate, intl)}</td>
            <td className={styles.description}>
              <div>
                <div className={styles.column}>
                  <span>{row.caseTitle}</span>
                </div>
              </div>
            </td>
            <td className={styles.description}>
              <div>
                <div className={styles.column}>
                  <span>{row.caseDescription}</span>
                </div>
              </div>
            </td>
            <td>{formatDate(row.caseDate, intl)}</td>
            <td className={styles.contextMenuWrapper}>
              <CaseDraftsMeatball draftId={row.draftId} onDelete={onDelete} translation={translation} portalTarget={portalTarget} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
));
